var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryMoneyTransfer32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1326.000000, -796.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/MoneyTransfer32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconTransfer",
    transform: "translate(4.000000, 6.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SwitchArrows"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,14.5 L20,18.5 L22.6666667,16.5 L20,14.5 Z M19,20.5 L19,12.5 L24.3333333,16.5 L19,20.5 Z",
    id: "End-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,1.5 L20,5.5 L22.6666667,3.5 L20,1.5 Z M19,7.5 L19,-0.5 L24.3333333,3.5 L19,7.5 Z",
    id: "End-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-2",
    points: "16.2619765 4 7.26197647 17 0 17 0 16 6.73802353 16 15.7380235 3 19 3 19 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-1",
    transform: "translate(9.500000, 10.000000) scale(1, -1) translate(-9.500000, -10.000000) ",
    points: "16.2619765 4 7.26197647 17 0 17 0 16 6.73802353 16 15.7380235 3 19 3 19 4"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryMoneyTransfer32);
export default __webpack_public_path__ + "static/media/spendCategoryMoneyTransfer32.24114d724dcca821573a706f58e22dcc.svg";
export { ForwardRef as ReactComponent };